import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, CircularProgress } from '@mui/material';

const Spinner = ({ isModal }) => {
    const theme = useTheme();

    const localTheme = {
        modalBox: {
            position: "fixed",
            marginLeft: "40%",
            top: "37%",
            paddingTop: theme.spacing(4)
        },
        box: {
            padding: theme.spacing(4),
            justifyContent: "center",
            display: "flex"
        },
        container: {

        }
    };

    return <>
        <Box style={isModal ? localTheme.modalBox : localTheme.box}>
            <Card elevation={isModal ? 1 : 0}>
                <CardContent>
                    <CircularProgress style={localTheme.container} />
                </CardContent>
            </Card>

        </Box>
    </>
}


Spinner.defaultProps = {
    isModal: true
}

export default Spinner;